class VariableRule {
    name;
    variable;
    css;
    nodes;
    constructor(name, variable, css){
        this.name = name;
        this.variable = variable;
        this.css = css;
        this.nodes = [];
        const hasDefaultValue = variable.value !== undefined;
        if (hasDefaultValue) {
            this.nodes.push(new VariableRuleNode(this.name, variable, css));
        }
        if (variable.modes) {
            for(const mode in variable.modes){
                const modeVariable = variable.modes[mode];
                const variableRule = new VariableRuleNode(this.name, modeVariable, css, mode);
                if (variableRule.modeTrigger) {
                    const isDefaultMode = hasDefaultValue ? false : this.css.config.defaultMode === mode;
                    variableRule.isDefaultMode = isDefaultMode;
                    if (isDefaultMode) {
                        this.nodes.unshift(variableRule);
                    } else {
                        this.nodes.push(variableRule);
                    }
                }
            }
        }
    }
    get key() {
        return this.name;
    }
    get text() {
        return this.nodes.map(({ text })=>text).join('');
    }
}
class VariableRuleNode {
    name;
    variable;
    css;
    mode;
    native;
    isDefaultMode;
    constructor(name, variable, css, mode){
        this.name = name;
        this.variable = variable;
        this.css = css;
        this.mode = mode;
        this.isDefaultMode = false;
    }
    get modeTrigger() {
        return this.mode ? this.css.config.modes?.[this.mode] : undefined;
    }
    get selectorText() {
        const isDefaultMode = this.isDefaultMode;
        if (this.mode) {
            switch(this.modeTrigger){
                case 'media':
                    return ':root';
                case 'host':
                    return `:host(.${this.mode})` + (isDefaultMode ? ',:host' : '');
                case 'class':
                    return `.${this.mode}` + (isDefaultMode ? ',:root' : '');
                default:
                    return '';
            }
        } else {
            return ':root';
        }
    }
    get text() {
        let text = `${this.selectorText}{--${this.name}:${String(this.variable.value)}}`;
        if (this.modeTrigger === 'media') {
            text = `@media (prefers-color-scheme:${this.mode}){${text}}`;
        }
        return text;
    }
}

export { VariableRuleNode, VariableRule as default };
